import request from '../request'

export function loginJWT(data) {
  return request({
    url: '/login',
    method: "post",
    data,
  })
}

export function getMe() {
  return request({
    url:'/user',
    method: "get"
  })
}

export function logoutUserJWT() {
  return request({
    url: '/logout',
    method:'post'
  })
}

// export function loginJWT(data) {
//   return request({
//     url: '/me',
//     method: "post",
//     data,
//   })
// }
